
import { AppRoutes } from './AppRoutes';
import LoginPage from '@/pages/LoginPage';

export default function AppRoutesIndex() {
  return <AppRoutes loginComponent={<LoginPage />} />;
}
